import React, { useContext, useEffect, useState } from 'react'
import { Context } from '../../Context/Context'
import { TOKEN, addNewFirmApi, approveUserApi, approveUserChangeOrgApi, checkIfFirmClaimedApi, denyUserApi, getUserDetailsToApproveApi, raiseNotificationApi } from '../../Constants';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowRight, User } from 'lucide-react';
import { toast } from 'react-toastify';

const withProtocol = (url) => !url ? '' : (/^https?:\/\//i.test(url) ? url : 'https://' + url);
const LINK_KEYS = ['lawFirmLink', 'linkedin'];
const mono = (color) => ({ font: "600 10.5px/1.2 'IBM Plex Mono',monospace", textTransform: 'uppercase', color });

function ApproveDeny({item, setUpdateList, onClose, initialDeny = false}) {
   // const {details} = useContext(Context);
   const [details, setDetails] = useState();
   const {makeApiCallFunc, setAwaitCount} = useContext(Context);
   const user = details?.user;
   const [labels,setLabels] = useState({});
   const updatedUserInfo = details?.updatedUserInfo;
   const [isUserAssistant, setIsUserAssistant] = useState(); 
   const token = localStorage.getItem(TOKEN);
   const navigate = useNavigate();
   useEffect(() => {
    if(details?.user?.isUserFunder)
    {
       setLabels({
           "First name" : "firstName",
           "Last name" : "lastName",
            "Email" : "email",
            "Litigation funder entity" : "company",
            "Years in business" : "experience",
            "User type" : "legalType",
            "Website" : "lawFirmLink",
            "Case preference" : "casePref",
            "State preference" : "statePref"
        });
    }
    else
    {
setLabels({
           "Profile picture" : "profilePic",
           "First name" : "firstName",
           "Last name" : "lastName",
            "Email" : "email",
            "Firm" : "company",
            "Phone number" : "phoneNumber",
            "Law firm website" : "lawFirmLink",
            "Experience" : "experience",
            "Designation" : "legalType",
            "LinkedIn" : "linkedin",
            "Case preference" : "casePref",
            "State preference" : "statePref"
        });
    }
   }, [details]);
  
   const attorneyLabels = {
    "Attorney's Profile picture" : "profilePic",
    "Attorney's First name" : "firstName",
    "Attorney's Last name" : "lastName",
    "Attorney's Email" : "email",
    "Attorney's Law Firm Link" : "lawFirmLink",
    "Attorney's LinkedIn URL" : "linkedin",

   }
   useEffect(() => {
    // makeApiCallFunc(getUserDetailsToApproveApi+"/"+id,
    // null,
    // ({data}) => {
        setDetails(item); 
        setIsUserAssistant(item?.user?.isUserAssistant );
    // },
    // (data) => console.log(data) 
    // )
   },[])
    
   const deny = () => {
    if (!feedbackMsg.trim()) { setFeedbackError(true); return; }
    setBusy(true);
    makeApiCallFunc(
        denyUserApi+details._id,
        {
            "feedback": feedbackMsg
        },
        ({data})=>
        {
            notifyUser(false);
            setAwaitCount(data?.awaits)
            toast.success('Denied — feedback sent to the attorney');
            onClose && onClose();
            navigate("/admin/approve");
        },
        (data) => { console.log(data); setBusy(false); toast.error('Could not deny. Please try again.'); }
    );
   }
   const notifyUser = (isVerified, emailAlreadySent = false) => {
    const notificationObj = {
      title : isVerified ?
      (user.verified ? "Account details approved and updated" : "Your account has been verified" )
      : 
      (user.verified ? "Your details has been rejected by the admin"  : "Your account details has been rejected and so is not verified"  ),
      is_read : false,
      sender: "admin",
      type: (isVerified ? "1" : "2"),
      notificationCategory: 0,
      receiver: user?._id,
      // in-app notification only - the email already went out from the server
      ...(emailAlreadySent ? { doNotSendEmail: true } : {}),
      content: 
      (isVerified ? 
        (user.verified ? 
        "Your account information has been verified and approved by the Admin."
        :
        "Congratulations your account has been verified. Now you shall start to request for the detailed view of the cases" )
        :
        (user.verified ? 
         "Your updates to the account has been denied by admin with the feedback - '"+feedbackMsg + "' .Please make the necessary changes and try again"  
            :
         "Your account has been denied verification with the feedback from the admin - '"+feedbackMsg + "' .Please make the necessary changes and try again"  
         )
         )
    }
    const successCallback = (data) => {
        setUpdateList(prev => !prev)

      console.log(data); 
    }
    const errorCallback = (data) => {
        console.log(data);
    }
    makeApiCallFunc(
        raiseNotificationApi, 
        notificationObj, 
        successCallback,
        errorCallback
        )
  }
   const [showFeedback, setShowFeedback] = useState(initialDeny);
   const [feedbackMsg, setFeedbackMsg] = useState("");
   const [feedbackError, setFeedbackError] = useState(false);
   const [busy, setBusy] = useState(false);

   const buildPostData = () => 
   {
        const postData = {};
        Object.entries(updatedUserInfo).map((item)=>{
            
                const {newValue} = updatedUserInfo[item[0]];
                if(details?.changeOrg === true || (details?.changeOrg === false && item[0] !== "casePref" && item[0] !== "statePref"))
                {
                    postData[item[0]] = newValue;
                }
            
           
        })
        return postData;
   }
   const approveUser = () => {
        setBusy(true);
        const postData = buildPostData();
        
        postData.verified = true;
        console.log(details)
        
        console.log(postData);

        if(details.changeOrg)
        {
            makeApiCallFunc(
                approveUserChangeOrgApi, 
                {
                    email: details.user.email, 
                    newEmail: updatedUserInfo?.email?.newValue,
                    newProfile: {...postData, legalType: details?.user?.legalType, role: 2, isUserAssistant: false},
                    accountId: details._id,
                },
                ({data})=>
                {
                   setAwaitCount(data?.awaits)
                   toast.success('Firm switch approved');
                   onClose && onClose();
                   setUpdateList(prev => !prev);
                   navigate("/admin/approve")
                },function (error) {
                console.log(error)
                setBusy(false)
                //setApiError(error?.response?.data?.message);
            })
        }
        else
        {
            if(postData?.lawFirmId && postData?.lawFirmId !== "none")
            {
            //check if selected firm is already with another user
            makeApiCallFunc(checkIfFirmClaimedApi, {firmId: postData?.lawFirmId}, (response) => {
                if(response?.data?.claimed)
                {
                    toast.error(`This firm is already claimed by ${response?.data?.claimedBy}. Please deny this user verification with valid message.`);
                    setFeedbackMsg(`Submitted firm is already claimed by ${response?.data?.claimedBy}. Only one case manager is allowed per firm.`);
                    setShowFeedback(true);
                    setBusy(false);
                    return;
                }   
                else
                {
                    approveUserFinal(postData, details);    
                }
            },
            (error) => {
                console.error("Error checking firm claim status:", error);
                setBusy(false);
                toast.error("Error checking firm claim status. Please try again.");
            });
            }
            else if(updatedUserInfo?.company?.newValue)
            {
                makeApiCallFunc(addNewFirmApi,{
                    name: updatedUserInfo?.company?.newValue,
                    website: updatedUserInfo?.lawFirmLink?.newValue,
                    phone: updatedUserInfo?.phoneNumber?.newValue
                },
                (response) => {
                    console.log("New firm added", response?.data);
                    postData.lawFirmId = response?.data?._id;
                    approveUserFinal(postData, details);
                },
                (error) => {
                    console.error("Error adding new firm:", error);
                    setBusy(false);
                    toast.error("Error adding new firm. Please try again.");
                }
            )
            } 
            else
            {
                approveUserFinal(postData, details);
            }
            console.log("postData", postData)
        }
        
   }
   const approveUserFinal = (
    postData, details
   ) => {
     makeApiCallFunc(
                approveUserApi, 
                {
                    user: postData, 
                    accountId: details._id, 
                    userId: details?.user._id, 
                    isEmailUpdate: details?.user?.verified, 
                },
                ({data})=>
                {
                    notifyUser(true, data?.verifiedEmailSent); // the server already emailed a verified law firm its saved cases
                    setAwaitCount(data?.awaits)
                    toast.success(details?.user?.verified ? 'Profile update approved' : 'Account verified');
                    onClose && onClose();
                    navigate("/admin/approve")
                },function (error) {
                console.log(error)
                setBusy(false)
                //setApiError(error?.response?.data?.message);
            })
        }
     const isChanged = (value) =>
        !!(updatedUserInfo?.[value] && updatedUserInfo?.[value].newValue &&
        (details?.changeOrg === true || (details?.changeOrg === false && value !== "casePref" && value !== "statePref")));
     const hideField = (label) => (user?.isUserFunder || user?.role === 5) && label.includes("picture");
     const entries = Object.entries(labels).filter(([label]) => !hideField(label));
     const changed = entries.filter(([, value]) => isChanged(value));
     const unchanged = entries.filter(([, value]) => !isChanged(value) && value !== 'profilePic');
     const changedCount = changed.length;

     const effective = (key) => isChanged(key) ? updatedUserInfo?.[key]?.newValue : user?.[key];
     const name = [effective('firstName'), effective('lastName')].filter(Boolean).join(' ');
     const firm = effective('company');
     const pic = effective('profilePic');
     const kind = details?.changeOrg ? 'Firm switch' : (user?.verified ? 'Profile update' : 'Verification request');

     const renderValue = (key, val, strong) => {
        if (Array.isArray(val)) {
            if (val.length === 0) return <span style={{ color: 'rgba(20,33,61,.5)', fontWeight: 400 }}>{key === 'casePref' ? 'All case types' : 'All states'}</span>;
            return <span>{val.join(', ')}</span>;
        }
        if (val === undefined || val === null || val === '') return <span style={{ color: 'rgba(20,33,61,.35)', fontWeight: 400 }}>Not provided</span>;
        if (LINK_KEYS.includes(key)) return <a href={withProtocol(val)} target="_blank" rel="noopener noreferrer" style={{ color: '#8a6231', textDecoration: 'underline', fontWeight: strong ? 600 : 400, wordBreak: 'break-all' }}>{val}</a>;
        return <span>{String(val)}</span>;
     };
     const avatar = (src, size = 40) => (
        <div className='flex-none flex items-center justify-center overflow-hidden rounded-full' style={{ width: size + 'px', height: size + 'px', background: 'rgba(20,33,61,.08)' }}>
            {src ? <img src={src} alt="" className='w-full h-full object-cover' /> : <User size={size * 0.45} strokeWidth={2} color='rgba(20,33,61,.45)' />}
        </div>
     );

     return (
        <>
        {details &&
        <div className='flex flex-col w-full font-plexsans' style={{ maxHeight: 'calc(100vh - 80px)' }}>
            {/* Header */}
            <div className='flex items-center justify-between bg-white flex-none' style={{ padding: '20px 28px', borderBottom: '1px solid rgba(20,33,61,.1)', gap: '16px' }}>
                <div className='flex items-center min-w-0' style={{ gap: '12px' }}>
                    {!hideField('Profile picture') && avatar(pic)}
                    <div className='min-w-0'>
                        <div className='truncate' style={{ font: "400 18px/1.3 'Spectral',serif", color: '#14213d' }}>{kind} — {name || 'Unnamed'}</div>
                        {firm && <div className='truncate' style={{ marginTop: '2px', fontSize: '12.5px', color: 'rgba(20,33,61,.5)' }}>{firm}</div>}
                    </div>
                </div>
                {(changedCount > 0 || !user?.verified) &&
                    <div className='flex-none' style={{ ...mono('#8a6231'), letterSpacing: '.06em', background: 'rgba(138,98,49,.1)', padding: '6px 12px', borderRadius: '4px' }}>
                        {changedCount > 0 ? `${changedCount} field${changedCount > 1 ? 's' : ''} changed` : 'New submission'}
                    </div>
                }
            </div>

            {/* Body */}
            <div className='overflow-y-auto flex-1' style={{ padding: '26px 28px', maxHeight: '440px', background: '#fff' }}>
                {changed.length > 0 &&
                    <div className='flex flex-col' style={{ gap: '12px', marginBottom: '22px' }}>
                        {changed.map(([label, value]) => {
                            const oldV = updatedUserInfo?.[value]?.oldValue;
                            const newV = updatedUserInfo?.[value]?.newValue;
                            const isPic = value === 'profilePic';
                            const long = !isPic && (String(Array.isArray(oldV) ? oldV.join(', ') : (oldV ?? '')).length > 60 || String(Array.isArray(newV) ? newV.join(', ') : (newV ?? '')).length > 60);
                            return (
                                <div key={value} style={{ border: '1.5px solid #8a6231', borderRadius: '6px', padding: '16px 18px' }}>
                                    <div style={{ ...mono('#8a6231'), letterSpacing: '.08em', marginBottom: '10px' }}>{label} — changed</div>
                                    {isPic ?
                                        <div className='flex items-center' style={{ gap: '14px' }}>
                                            <div style={{ opacity: .6 }}>{avatar(oldV, 48)}</div>
                                            <ArrowRight size={14} color='rgba(20,33,61,.4)' />
                                            {avatar(newV, 48)}
                                        </div>
                                    :
                                        <div className={long ? 'flex flex-col' : 'flex items-center flex-wrap'} style={{ gap: long ? '8px' : '14px', fontSize: '14px' }}>
                                            <span style={{ color: 'rgba(154,59,46,.8)', textDecoration: 'line-through' }}>{renderValue(value, oldV)}</span>
                                            {!long && <ArrowRight size={14} color='rgba(20,33,61,.4)' className='flex-none' />}
                                            <span style={{ color: '#14213d', fontWeight: 600 }}>{renderValue(value, newV, true)}</span>
                                        </div>
                                    }
                                </div>
                            );
                        })}
                    </div>
                }

                {isUserAssistant && (updatedUserInfo?.legalType?.newValue || user?.legalType) &&
                    <div style={{ ...mono('rgba(20,33,61,.4)'), letterSpacing: '.06em', marginBottom: '14px' }}>{updatedUserInfo?.legalType?.newValue || user?.legalType}</div>
                }

                <div className='grid grid-cols-1 sm:grid-cols-2' style={{ gap: '16px 28px' }}>
                    {unchanged.map(([label, value]) => (
                        <div key={value} className={value === 'company' ? 'sm:col-span-2' : ''}>
                            <div style={{ ...mono('rgba(20,33,61,.4)'), letterSpacing: '.06em', marginBottom: '5px' }}>{label}</div>
                            <div style={{ fontSize: '14px', color: '#14213d', lineHeight: 1.45, wordBreak: 'break-word' }}>{renderValue(value, user?.[value])}</div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Footer */}
            <div className='flex-none' style={{ background: '#f7f4ed', padding: '18px 28px', borderTop: '1px solid rgba(20,33,61,.1)' }}>
                {showFeedback ?
                    <div>
                        <label htmlFor='admin-feedback' style={{ display: 'block', font: "600 12.5px/1 'IBM Plex Sans',sans-serif", color: '#14213d', marginBottom: '8px' }}>Feedback to attorney <span style={{ color: '#9a3b2e' }}>*</span></label>
                        <textarea
                            id='admin-feedback'
                            autoFocus
                            rows={3}
                            value={feedbackMsg}
                            onChange={(e) => { setFeedbackMsg(e.target.value); if (feedbackError) setFeedbackError(false); }}
                            placeholder='Explain what needs to change — the attorney will see this.'
                            className='w-full bg-white focus:outline-none focus:ring-1 focus:ring-tan resize-y'
                            style={{ border: '1px solid ' + (feedbackError ? '#9a3b2e' : 'rgba(20,33,61,.15)'), borderRadius: '5px', padding: '10px 12px', fontSize: '13.5px', color: '#14213d' }}
                        />
                        {feedbackError && <div style={{ fontSize: '12px', color: '#9a3b2e', marginTop: '4px' }}>A reason is required to deny.</div>}
                        <div className='flex' style={{ gap: '10px', marginTop: '12px' }}>
                            <button type='button' disabled={busy} onClick={deny}
                                className='flex-1 transition-colors disabled:opacity-60'
                                style={{ background: '#9a3b2e', color: '#fffdf8', font: "500 13px/1 'IBM Plex Sans',sans-serif", padding: '13px', borderRadius: '4px' }}>
                                {busy ? 'Denying…' : 'Deny'}
                            </button>
                            <button type='button' onClick={() => { setShowFeedback(false); setFeedbackError(false); }}
                                className='transition-colors hover:bg-white'
                                style={{ color: 'rgba(20,33,61,.6)', border: '1px solid rgba(20,33,61,.2)', font: "500 13px/1 'IBM Plex Sans',sans-serif", padding: '13px 20px', borderRadius: '4px' }}>
                                Cancel
                            </button>
                        </div>
                    </div>
                :
                    <div className='flex flex-wrap sm:flex-nowrap' style={{ gap: '10px' }}>
                        <button type='button' disabled={busy} onClick={approveUser}
                            className='flex-1 bg-tan hover:bg-tanDark transition-colors disabled:opacity-60'
                            style={{ color: '#fffdf8', font: "500 13px/1 'IBM Plex Sans',sans-serif", padding: '13px', borderRadius: '4px', minWidth: '140px' }}>
                            {busy ? 'Approving…' : 'Approve'}
                        </button>
                        <button type='button' disabled={busy} onClick={() => setShowFeedback(true)}
                            className='flex-1 bg-white transition-colors hover:bg-[rgba(154,59,46,0.04)] disabled:opacity-60'
                            style={{ color: '#9a3b2e', border: '1px solid rgba(154,59,46,.35)', font: "500 13px/1 'IBM Plex Sans',sans-serif", padding: '13px', borderRadius: '4px', minWidth: '180px' }}>
                            Provide feedback &amp; deny
                        </button>
                        <button type='button' onClick={onClose}
                            className='transition-colors hover:bg-white'
                            style={{ color: 'rgba(20,33,61,.6)', border: '1px solid rgba(20,33,61,.2)', font: "500 13px/1 'IBM Plex Sans',sans-serif", padding: '13px 20px', borderRadius: '4px' }}>
                            Back to list
                        </button>
                    </div>
                }
            </div>
        </div>
        }
        </>
  )
}

export default ApproveDeny